import React from "react";

import { LayoutMain } from "@unisearch/theme/layout";
import { TermsConditions, TermsHero } from "@modules/study/terms";

const TermsAndConditions = () => {
  return (
    <LayoutMain
      title="Terms and Conditions"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/terms-and-conditions`}
    >
      <TermsHero title={"Terms of Service"} />
      <TermsConditions />
    </LayoutMain>
  );
};

export default TermsAndConditions;
